"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localityAliases = exports.findAlias = exports.aliasesForRegion = exports.CapitalRegion = exports.CanberraQueanbeyan = void 0;
var _node = require("@domain-group/fe-allhomes-library/lib/node");
var localityAliases = exports.localityAliases = [{
  name: 'Capital Region',
  slug: 'capital-region',
  newListingsSlug: 'canberra-act',
  localities: [_node.LocalityCommonRegion.CANBERRA, _node.LocalityCommonDistrict.GREATER_QUEANBEYAN, {
    id: 2072,
    slug: 'bungendore-braidwood-queanbeyan-region-nsw',
    type: 'DISTRICT'
  }, {
    id: 1517,
    slug: 'cooma-snowy-nsw',
    type: 'DISTRICT'
  }, {
    id: 2431,
    slug: 'yass-valley-southern-tablelands-nsw',
    type: 'DISTRICT'
  }],
  metaData: {
    state: 'ACT'
  },
  regionId: '391'
}, {
  name: 'Canberra & Queanbeyan',
  slug: 'canberra-queanbeyan',
  newListingsSlug: 'canberra-queanbeyan',
  localities: [_node.LocalityCommonRegion.CANBERRA, _node.LocalityCommonDistrict.GREATER_QUEANBEYAN],
  metaData: {
    state: 'ACT'
  },
  regionId: '391'
}];
var CapitalRegion = exports.CapitalRegion = localityAliases[0];
var CanberraQueanbeyan = exports.CanberraQueanbeyan = localityAliases[1];
var findAlias = locality => localityAliases.find(alias => alias.newListingsSlug === locality.newListingsSlug || alias.slug === locality.slug);
exports.findAlias = findAlias;
var aliasesForRegion = regionId => localityAliases.filter(alias => alias.regionId === regionId);
exports.aliasesForRegion = aliasesForRegion;